export interface AdminSiteLogoutResponse {
  success: boolean;
  message?: string;
  data?: {
    logout_url?: string;
  };
}

type AdminSiteLogoutRequest = (
  site: string,
  bearerToken: string | null,
) => Promise<AdminSiteLogoutResponse>;

type AdminSiteSessionStorage = Pick<Storage, 'getItem'>;

export type AdminLogoutTransport = 'bearer' | 'cookie' | 'local';

export const selectAdminLogoutTransport = ({
  hasBearerToken,
  hasCookieSession,
}: {
  hasBearerToken: boolean;
  hasCookieSession: boolean;
}): AdminLogoutTransport => {
  if (hasBearerToken) {
    return 'bearer';
  }

  return hasCookieSession ? 'cookie' : 'local';
};

export const logoutAdminSite = async (
  site: string,
  request: AdminSiteLogoutRequest,
  storage: AdminSiteSessionStorage,
  exactBearerToken: string | null = storage.getItem('site_admin_token'),
): Promise<AdminSiteLogoutResponse> => {
  return request(site, exactBearerToken);
};
